import React, { useEffect, useState } from "react";
import { sendTransactions } from "../../api";
import {
  ChevronLeft,
  ChevronRight,
  ArrowUpDown,
} from "lucide-react";

const SenTransaction = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));
  const userToken = user?.user_token;

  useEffect(() => {
    if (!userToken) return;

    const fetchTransactions = async () => {
      try {
        setLoading(true);
        const res = await sendTransactions({
          user_token: userToken,
          page,
          limit,
          search,
        });
        setTransactions(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      } catch (err) {
        console.error("Error fetching transactions:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [userToken, page, limit, search]);

  return (
    <div className="main-content p-6">
      <div className="table-list-transaction py-5">
        {/* Search + Limit */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4">
          <form
            className="flex w-full md:w-1/2 rounded-lg border shadow-sm overflow-hidden"
            onSubmit={(e) => {
              e.preventDefault();
              setPage(1);
            }}
          >
            <input
              type="text"
              placeholder="Search by Order ID or Txn ID"
              className="px-3 py-2 w-full outline-none"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 flex items-center gap-2 hover:bg-blue-700"
            >
              Search
            </button>
          </form>

          <select
            className="border px-3 py-2 rounded-lg shadow-sm"
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
          >
            <option value={5}>5 per page</option>
            <option value={10}>10 per page</option>
            <option value={20}>20 per page</option>
            <option value={50}>50 per page</option>
            <option value={100}>100 per page</option>
            <option value={500}>500 per page</option>
          </select>
        </div>

        {/* Table */}
        <div className="overflow-x-auto border rounded-lg shadow bg-black text-white">
          <div className="list-transaction-head1 title-sort grid grid-cols-7 bg-gray-900 text-white">
            {[
              "Transaction ID",
              "Date",
              "Name",
              "Email",
              "Coin",
              "Amount",
              "Status",
            ].map((head) => (
              <div
                key={head}
                className="btn-key-sort flex items-center justify-between px-4 py-3 border-b cursor-pointer"
              >
                <span className="f12-bold">{head}</span>
                <ArrowUpDown size={14} />
              </div>
            ))}
          </div>

          <table className=" content-sort w-full">
            <tbody>

                {loading ? (
  <div className="flex justify-center items-center py-10">
    <div className="w-8 h-8 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
  </div>
) :transactions.length > 0 ? (
                        transactions.map((tx) => (
                          <tr key={tx.id} className="tf-table-item" style={{color: 'black'}}>
                            <td>#{tx.transaction_id}</td>
                            <td>
                              {new Date(tx.created_at).toLocaleDateString()} <br />
                              <span className="f12-medium">{new Date(tx.created_at).toLocaleTimeString()}</span>
                            </td>
                            <td>{tx.name}</td>
                            <td>{tx.email}</td>
                            <td>{tx.chain.toUpperCase()}</td>
                            <td>${tx.amount}</td>
                            <td>
                              <div
                                className={`box-status ${
                                  tx.status.toLowerCase() === "complete"
                                    ? "bg-YellowGreen"
                                    : tx.status.toLowerCase() === "failed"
                                    ? "bg-LightGray type-red"
                                    : "bg-LightGray"
                                }`}
                              >
                                <span className="font-poppins">{tx.status}</span>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr style={{color: 'black'}}>
                          <td colSpan="8" style={{ textAlign: "center" }}>
                            No transactions found
                          </td>
                        </tr>
                      )}

             
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-center items-center gap-3 mt-4">
          <button
            className="p-2 border rounded-lg disabled:opacity-50 hover:bg-gray-100 text-black"
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            <ChevronLeft size={18} />
          </button>
          <span className="text-sm font-medium text-black">
            Page {page} of {totalPages}
          </span>
          <button
            className="p-2 border rounded-lg disabled:opacity-50 hover:bg-gray-100 text-black"
            disabled={page === totalPages}
            onClick={() => setPage((prev) => prev + 1)}
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SenTransaction;
